import r from "dayjs";
import Y from "dayjs/plugin/advancedFormat";
import c from "dayjs/plugin/customParseFormat";
import R from "dayjs/plugin/isLeapYear";
import d from "dayjs/plugin/isSameOrAfter";
import p from "dayjs/plugin/isSameOrBefore";
import { D as o } from "./constants-C9JADvZj.mjs";
import { S as L } from "./errors-YTprc4A2.mjs";
r.extend(c);
r.extend(p);
r.extend(d);
r.extend(R);
r.extend(Y);
const E = r().startOf("day");
function u(t, e = "FullDate", a = o.DATE_DIVIDER_CHAR) {
  if (!t)
    throw new L("No value was provided");
  const n = t.split(a), s = e === "FullDate" ? n[0] : "", i = e === "FullDate" ? n[1] : n[0], f = e === "FullDate" ? n[2] : n[1];
  return e === "FullDate" ? `${s}${a}${i}${a}${f}` : `${i}${a}${f}`;
}
function M(t, e = "FullDate") {
  let a;
  return t ? a = r(
    t,
    e === "FullDate" ? o.MONTH_YEAR_FORMAT : o.FULL_DATE_FORMAT
  ) : a = r(), a.unix();
}
const A = (t) => E.format(
  t === "FullDate" ? o.FULL_DATE_FORMAT : o.MONTH_YEAR_FORMAT
);
function _(t = "", e = o.DISPLAY_FORMAT) {
  return t ? r(t, e) : r().format(e);
}
function F(t, e, a, n, s = o.FULL_DATE_FORMAT) {
  return r(
    t,
    n === "MonthYear" ? o.MONTH_YEAR_FORMAT : o.FULL_DATE_FORMAT
  ).add(e, a).format(s);
}
function T(t, e = o.FULL_DATE_FORMAT) {
  const a = r(t, e);
  return a.isValid() && a.format(e) === t;
}
function S(t, e = o.MONTH_YEAR_FORMAT) {
  return r(t, e).isValid() && r(t, e).format(e) === t;
}
function l(t, e, a = {
  unit: "millisecond",
  format: o.FULL_DATE_FORMAT
}) {
  let n, s;
  return typeof t == "number" ? (n = r(t), s = r(e)) : (n = r(t, a.format), s = r(e, a.format)), Math.abs(n.diff(s, a.unit, !0));
}
function m(t, e, a) {
  let n, s;
  return typeof t == "string" ? n = r(
    t,
    a === "MonthYear" ? o.MONTH_YEAR_FORMAT : o.FULL_DATE_FORMAT
  ) : n = r(t), typeof e == "string" ? s = r(
    e,
    a === "MonthYear" ? o.MONTH_YEAR_FORMAT : o.FULL_DATE_FORMAT
  ) : s = r(e), n.isAfter(s) ? 1 : n.isSame(s) ? 0 : -1;
}
function D(t, e, a) {
  return r(`${a}-${e}-${t}`).format("D MMMM YYYY");
}
function O() {
  return r().toISOString();
}
const $ = {
  valueToString: u,
  getTimestamp: M,
  NowAsString: A,
  format: _,
  add: F,
  isDDMMYYYY: T,
  diff: l,
  compare: m,
  isoDateTimeNow: O,
  formatDMMMMYYYY: D
}, j = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NowAsString: A,
  add: F,
  compare: m,
  default: $,
  diff: l,
  format: _,
  formatDMMMMYYYY: D,
  getTimestamp: M,
  isDDMMYYYY: T,
  isMMYYYY: S,
  isoDateTimeNow: O,
  valueToString: u
}, Symbol.toStringTag, { value: "Module" }));
export {
  A as N,
  F as a,
  S as b,
  l as c,
  j as d,
  m as e,
  _ as f,
  M as g,
  D as h,
  T as i,
  O as j,
  $ as k,
  u as v
};
